import { Link } from "react-router-dom";

const GillcoLogo = ({ variant = "light", size = "default" }) => {
  const sizeClass = size === "footer"? "h-14 sm:h-16 object-contain": "h-14 sm:h-16 object-contain";

  return (
    <Link to="/" aria-label="Go to Home">{variant === "light" ? (<img src="/gillco-logo-white.png" alt="Gillco Group" className={sizeClass} />) : (<img src="/gillco-logo-original.png" alt="Gillco Group" className={sizeClass} /> )}</Link>
  );
};

export default GillcoLogo;